import React from "react";
import { Button, DropdownButton, Dropdown } from "react-bootstrap";
import { withTranslation, WithTranslation } from "react-i18next";
import BackButton from "../../../common/BackButton";
import "../../../../main.css";
import "../../projectdetail.css";

export interface IProps extends WithTranslation {
  /**
   * タイトルラベル
   */
  label: string;
  /**
   * チャート一覧テーブルCSSスタイル
   */
  chartTableStyle: React.CSSProperties;
  /**
   * チャート一覧テーブル
   */
  chartTable: JSX.Element[];
  /**
   * 作成ボタンを表示する場合はtrue
   */
  isCreateEnabled: boolean;
  /**
   * 戻るボタンが押された場合に呼び出されます
   */
  onBack: () => void;
  /**
   * 作成ボタンが押された場合に呼び出されます
   */
  onCreate: () => void;
  /**
   * 一括設定項目が変更された場合に呼び出されます
   * @param value - 設定値
   */
  onChangeAll: (value: number) => void;
}

class ProfileListPanel extends React.Component<IProps> {
  render() {
    const {
      isCreateEnabled,
      label,
      onBack,
      onCreate,
      onChangeAll,
      chartTableStyle,
      chartTable,
      t,
    } = this.props;
    const createBtn = isCreateEnabled ? (
      <Button className="btn-mainspace" onClick={onCreate}>
        {label}
      </Button>
    ) : (
      ""
    );
    return (
      <div className="mainspace">
        <div className="mainspace-title">
          <h3>{label}</h3>
        </div>
        <div className="mainspace-title">{t("profile_create_caption")}</div>
        <div className="mainspace-toolbar">
          <BackButton onClick={onBack} />
          {createBtn}
          <DropdownButton
            className="btn-mainspace"
            title={t("profile_settings_all")}
          >
            <Dropdown.Item onClick={() => onChangeAll(1)}>
              {t("profile_settings_use")}
            </Dropdown.Item>
            <Dropdown.Item onClick={() => onChangeAll(0)}>
              {t("profile_settings_unused")}
            </Dropdown.Item>
          </DropdownButton>
        </div>
        <div className="chart-list-area">
          <div style={chartTableStyle}>{chartTable}</div>
        </div>
      </div>
    );
  }
}

/**
 * プロファイル一覧画面
 */
export default withTranslation()(ProfileListPanel);
